// extracted by mini-css-extract-plugin
export default {"formContainerClassName":"BusinessInfoTab_formContainerClassName__QiJ+Z","businessBtnLink":"BusinessInfoTab_businessBtnLink__LuS6H"};